class ClipboardManager {
  copy = (str) => {
    return navigator.clipboard.writeText(str);
  };
}

export const clipboardManager = new ClipboardManager();
